import { render } from "./ButtonTrailer.vue?vue&type=template&id=67e09eaa"
import script from "./ButtonTrailer.vue?vue&type=script&lang=js"
export * from "./ButtonTrailer.vue?vue&type=script&lang=js"

import "./ButtonTrailer.vue?vue&type=style&index=0&id=67e09eaa&lang=css"
script.render = render

export default script